import { ClientEvents } from 'common/events/ClientEvents';
import { Router } from 'next/router';
import { parse as parseQueryString } from 'query-string';
import { useCallback, useEffect } from 'react';
import { ITracker } from 'tracking/ITracker';
import { useOnMount } from 'web-common/src/shared/hooks/useOnMount';

export const usePageViewTracking = (router: Router, tracker: ITracker) => {
  const trackPageView = useCallback(() => {
    const widthPixels = Math.max(document.documentElement.clientWidth ?? 0, window.innerWidth ?? 0);
    const heightPixels = Math.max(document.documentElement.clientHeight ?? 0, window.innerHeight ?? 0);

    tracker.track(ClientEvents.PAGE_VIEW, {
      params: router.query,
      pattern: router.pathname,
      preferredColorTheme: null,
      queryParams: window.location.search ? parseQueryString(window.location.search) : null,
      route: window.location.pathname + window.location.search,
      viewportDimensions: { widthPixels, heightPixels },
    });
  }, [router.pathname, router.query, tracker]);

  // Track the initial page view
  useOnMount(trackPageView);

  // Track all route changes
  useEffect(() => {
    router.events.on('routeChangeComplete', trackPageView);
    return () => {
      router.events.off('routeChangeComplete', trackPageView);
    };
  }, [trackPageView, router.events]);
};
